import { useMemo } from 'react';
import { useOverlayTriggerState } from 'react-stately';
import { getPlatformStyles } from '@direct-frontend/platform-code';

import { Drawer, DrawerHeader } from '../Drawer';
import { cn } from '../../lib/css/className/className';

import { MenuTriggerProps } from './types';
import { MenuListContext, MenuListContextType } from './utils';

getPlatformStyles({
    mobile: import('./MenuTrigger@mobile.css'),
});

export const cls = cn('MenuTrigger');

export default function MenuTrigger(props: MenuTriggerProps) {
    const { trigger, children, isOpen, defaultOpen, onOpenChange, 'data-testid': dataTestId = 'MenuTrigger' } = props;

    const {
        isOpen: isMenuOpen,
        toggle,
        close,
    } = useOverlayTriggerState({
        isOpen,
        defaultOpen,
        onOpenChange,
    });

    const contextValue: MenuListContextType = useMemo(
        () => ({
            triggerRef: null,
            levels: null,
            onItemClick: close,
        }),
        [close],
    );

    return (
        <>
            {trigger({ onClick: toggle, onPress: toggle }, { isOpen: isMenuOpen })}
            <Drawer
                isOpen={isMenuOpen}
                onClose={close}
                data-testid={`${dataTestId}.Drawer`}
                header={<DrawerHeader onCancelClick={close} data-testid={`${dataTestId}.Header`} />}
                className={cls('drawer')}
            >
                <MenuListContext.Provider value={contextValue}>{children}</MenuListContext.Provider>
            </Drawer>
        </>
    );
}
